import React, { useState } from 'react';
import { Dropdown } from 'telstra-ui/components/drop-down/Dropdown';
import { TextInput } from 'telstra-ui/components/text-input/TextInput';
import { SvgIcon } from 'telstra-ui/components/svg/Icon';
import { ToolTip } from 'telstra-ui/components/tool-tip/Tooltip';
import { Button } from 'telstra-ui/components/button/Button';
import Modal from 'telstra-ui/components/modal/Modal';
import renderHTML from 'react-render-html';
import Pagination from 'telstra-ui/components/pagination/Pagination';
import { prepareDropDownOptionsArry } from '../../amc-homepage.actions';
import { formatPhoneNumber } from '../../../ffwd-homepage/ffwd-homepage.actions';
import UnaddressFilters from '../unaddress-filters/unaddress-filters';
import './unaddressable-table.css';

const UnaddressableTable = (props) => {
  const {
    authorableContent,
    authorableContent: {
      formFields: {
        unaddressSearchFields,
      },
      username,
      currentPlanName,
      dataAllowanceConsume,
      data,
      gbText,
      cost,
      serviceNumber,
      paginationNumbers,
      paginationBaseNumber,
      treatment,
      treatmentTooltip,
      deviceType,
      tooltip5g,
      filterClearAll,
      filterEditTopLink,
      filterTopLink,
    },
    serviceNumbersPlanDetails,
    serviceNumbersWithFlag,
    searchUnaddressSelectedOption,
    onSearchUnaddressFieldChange,
    pageChangeHandler,
    currentPage,
    sorting,
    sortingClick,
    searchTextChange,
    searchText,
    currentPlanList,
    currentDevicesList,
    unaddressTreatmentList,
  } = props;

  const [filterOpen, setFilterOpen] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [filterApplied, setFilterApplied] = useState(false);
  const [filterClearAllStatus, setFilterClearAllStatus] = useState(false);
  const [totalRecords, setTotalRecords] = useState(serviceNumbersPlanDetails.length);
  const [planSearchText, setPlanSearchText] = useState('');
  const [filterSearchedResults, setFilterSearchedResults] = useState([]);

  const [pageSize, setPageSize] = useState(parseInt(paginationBaseNumber, 10));
  const [treatmentModalIsOpen, setTreatmentModalIsOpen] = useState(false);
  const numberOfPages = filterApplied ? Math.ceil(totalRecords / pageSize) : Math.ceil(serviceNumbersPlanDetails.length / pageSize);
  const pageSizeOptions = paginationNumbers.split(',');

  const onPageChange = (pageNumber) => {
    pageChangeHandler(pageNumber, 'unaddressable-table-section');
  };

  const onPageSizeChange = (newPageSize) => {
    setPageSize(newPageSize);
    setTimeout(() => {
      const lastTableRow = document.getElementById('unaddressable-table').lastElementChild.lastElementChild;
      lastTableRow.scrollIntoView();
    }, 200);
  };

  const openTreatmentDetails = () => {
    setTreatmentModalIsOpen(true);
  };

  const searchFieldsDropDownOptions = prepareDropDownOptionsArry(unaddressSearchFields.options);

  const getSearchSelectionValue = (searchKey) => {
    const option = unaddressSearchFields.options.find(item => item.key === searchKey);
    const defaultOption = unaddressSearchFields.options.find(item => item.key === 'nosearch');
    if (option) {
      return option.value;
    }
    return defaultOption.value;
  };

  const onSearchText = () => {
    if (filterApplied) {
      return planSearchText;
    }
    return searchText;
  };

  const onSearchTextChange = (event) => {
    const filterSearchText = event.target.value;
    setPlanSearchText(filterSearchText);
    if (filterApplied) {
      let filterResults = [];
      if (searchUnaddressSelectedOption === 'number') {
        filterResults = filteredData.filter(numbers => numbers.serviceNumber.includes(filterSearchText));
      } else if (searchUnaddressSelectedOption === 'username') {
        filterResults = filteredData.filter(numbers => numbers.userName.toLowerCase().includes(filterSearchText.toLowerCase()));
      } else if (searchUnaddressSelectedOption === 'currentplan') {
        filterResults = filteredData.filter(numbers => numbers.unaddressableCurrentPlan.toLowerCase().includes(filterSearchText.toLowerCase()));
      } else if (searchUnaddressSelectedOption === 'nosearch') {
        filterResults = filteredData;
        setPlanSearchText('');
      }
      onPageChange(0);
      setTotalRecords(filterResults.length);
      setFilterSearchedResults(filterResults);
    } else {
      searchTextChange(event);
    }
  };

  const onSearchDropDownChange = (event) => {
    if (filterApplied) {
      setPlanSearchText('');
      setFilterSearchedResults(filteredData);
      setTotalRecords(filteredData.length);
      onSearchUnaddressFieldChange(event);
    } else {
      onSearchUnaddressFieldChange(event);
    }
  };

  const applyFilterOnFullData = (filterObj) => {
    let filterResults = serviceNumbersPlanDetails;

    if (filterObj.fiveGCheck) {
      filterResults = filterResults.filter(itm => itm.fiveGInteraction === '1');
    }
    if (filterObj.voiceCheck) {
      filterResults = filterResults.filter(itm => serviceNumbersWithFlag[itm.serviceNumber].dataOnly === false);
    }
    if (filterObj.dataCheck) {
      filterResults = filterResults.filter(itm => serviceNumbersWithFlag[itm.serviceNumber].dataOnly === true);
    }
    if (filterObj.currentPlanSelected.length > 0) {
      let currentPlanResults = [];
      filterObj.currentPlanSelected.forEach((plan) => {
        const planResults = filterResults.filter(itm => itm.unaddressableCurrentPlan.toLowerCase() === plan.toLowerCase());
        currentPlanResults = [...currentPlanResults, ...planResults];
      });
      filterResults = [...currentPlanResults];
    }
    if (filterObj.currentDeviceValues.length > 0) {
      let currentDeviceResults = [];
      filterObj.currentDeviceValues.forEach((dev) => {
        const deviceResults = filterResults.filter(itm => itm.deviceType.toLowerCase() === dev.toLowerCase());
        currentDeviceResults = [...currentDeviceResults, ...deviceResults];
      });
      filterResults = [...currentDeviceResults];
    }
    if (filterObj.currentTreatmentsValues.length > 0) {
      let currentTreatmentResults = [];
      filterObj.currentTreatmentsValues.forEach((dev) => {
        const treatmentResults = filterResults.filter(itm => itm.treatmentName.toLowerCase() === dev.toLowerCase());
        currentTreatmentResults = [...currentTreatmentResults, ...treatmentResults];
      });
      filterResults = [...currentTreatmentResults];
    }
    onPageChange(0);
    setPlanSearchText('');
    setFilterApplied(true);
    setFilteredData(filterResults);
    setFilterOpen(false);
    setFilterClearAllStatus(false);
    setTotalRecords(filterResults.length);
  };

  const clearFilterApplied = () => {
    setFilterApplied(false);
    setFilterOpen(false);
    setFilterClearAllStatus(true);
  };

  const cancelFilter = () => {
    setFilterApplied(false);
    setFilterOpen(false);
    setFilterClearAllStatus(false);
  };

  const getDataRows = () => {
    if (filterApplied && planSearchText.length > 0) {
      return filterSearchedResults;
    } else if (filterApplied) {
      return filteredData;
    }
    return serviceNumbersPlanDetails;
  };

  const rowData = dataTable => dataTable.slice(currentPage * pageSize, pageSize * (currentPage + 1)).map(service => (
    <tr key={`${service.serviceNumber}`}>
      <td className="sticky-col">
        {service.dataOnly === true &&
          <div className={`table-item-text ri-flex-pill-width inline ${service.ncServiceType === true ? 'hidden' : ''}`}>
            <SvgIcon name="icon-authentication-hotspot" className="mobile-pill-icon" />
          </div>
        }
        {service.dataOnly === false &&
          <div className={`table-item-text ri-flex-pill-width inline ${service.ncServiceType === true ? 'hidden' : ''}`}>
            <SvgIcon name="icon-mobiles-mobile" className="mobile-pill-icon" />
          </div>
        }
      </td>
      <td className="sticky-col1">
        <div className="table-item-text ri-flex-service-width inline">{formatPhoneNumber(service.serviceNumber)}</div>
        {service.suggestedPlanName === 'unaddressableServices' &&
          <div className="table-item-text ri-flex-service-width inline">
            {service.fiveGInteraction === '1' &&
              <div className="p-2 table-item-text ri-flex-pill-width inline">
                <SvgIcon name="icon-bill-5g" className="mobile-pill-icon" />
              </div>
            }
            {service.fiveGInteraction !== '1' &&
              <div className="p-2 table-item-text ri-flex-pill-width-not-5g inline">
                <SvgIcon name="icon-system-circle-filled" className="mobile-pill-icon" />
              </div>
            }
          </div>
        }
      </td>
      <td><div className="table-item-text">{service.userName}</div></td>
      <td><div className="table-item-text">{service.unaddressableCurrentPlan}</div></td>
      <td><div className="table-item-text">{service.currentPlanCost}</div></td>
      <td>
        <div className="table-item-text">{service.dataUsage}{gbText} <br />
          <span className="trade-in-note">({service.dataAllowance}{gbText})</span>
        </div>
      </td>
      <td><div className="table-item-text">{service.treatmentName}</div></td>
      <td><div className="table-item-text">{service.deviceType}</div></td>
    </tr>
  ));

  return (
    <div id="unaddressable-table-section" className="unaddressable-table-section">
      <div className="plan-offer-table">
        <div className="row table-nav">
          <div className="col-4 offset-1 search-field-option">
            {(filterOpen === false) &&
              <Dropdown
                value={getSearchSelectionValue(searchUnaddressSelectedOption)}
                dropdownId="search-plan-field-option"
                options={searchFieldsDropDownOptions}
                onOptionClick={onSearchDropDownChange}
                className="search-field-option-container"
              />
            }
          </div>
          <div className="col-4 search-field-option-text">
            {(filterOpen === false) &&
              <TextInput
                name="trade-search-text"
                onChange={onSearchTextChange}
                placeholder={unaddressSearchFields.placeholder}
                value={onSearchText()}
              />
            }
          </div>
          <div className="col-1 table-action">
            {filterApplied &&
              <Button
                variant="primary"
                onClick={() => clearFilterApplied()}
                size="medium"
              >
                {filterClearAll}
              </Button>
            }
          </div>
          <div className="col-1 offset-1 table-action filter-button">
            <SvgIcon name="icon-product-filter" className="icon-filter" />
            <Button
              variant="secondary"
              size="medium"
              state="app"
              className="filter-button"
              onClick={() => setFilterOpen(!filterOpen)}
            > {filterApplied ? filterEditTopLink : filterTopLink}</Button>
          </div>
        </div>
        <div className="col-12">
          <UnaddressFilters
            authorableContent={authorableContent}
            currentPlanList={currentPlanList}
            currentDevicesList={currentDevicesList}
            unaddressTreatmentList={unaddressTreatmentList}
            filterOpen={filterOpen}
            applyFilter={applyFilterOnFullData}
            cancelFilter={cancelFilter}
            filterClearAll={filterClearAllStatus}
            filterApplied={filterApplied}
          />
        </div>
        <div id="unaddressable-table-section" className="unaddressable-table-section row">
          <div className="sticky-wrapper col-12">
            <div className="sticky-scroller">
              <table className="sticky-table" id="unaddressable-table">
                <thead>
                  <tr>
                    <th className="sticky-col">&nbsp;</th>
                    <th className="sticky-col1">
                      <div className="table-title">
                        {serviceNumber}
                        <ToolTip
                          description={renderHTML(tooltip5g)}
                          activeIconName="icon-system-info"
                          iconName="icon-system-info-default"
                          position="bottom"
                        />

                        {sorting.numberSortType === 'ASC' &&
                          <div
                            className="number-sort-asc"
                            onClick={() => sortingClick('number', 'DESC')}
                            role="button"
                            tabIndex="0"
                          />
                        }
                        {sorting.numberSortType === 'DESC' &&
                          <div
                            className="number-sort-desc"
                            onClick={() => sortingClick('number', 'ASC')}
                            role="button"
                            tabIndex="0"
                          />
                        }
                      </div>
                    </th>
                    <th>
                      <div className="table-title ri-flex-elarge-width">
                        {username}
                        {sorting.userSortType === 'ASC' &&
                          <div
                            className="user-sort-asc"
                            onClick={() => sortingClick('userName', 'DESC')}
                            role="button"
                            tabIndex="0"
                          />
                        }
                        {sorting.userSortType === 'DESC' &&
                          <div
                            className="user-sort-desc"
                            onClick={() => sortingClick('userName', 'ASC')}
                            role="button"
                            tabIndex="0"
                          />
                        }
                      </div>
                    </th>
                    <th>
                      <div className="table-title ri-flex-elarge-width">
                        {currentPlanName}
                        {sorting.currentPlanNameSortType === 'ASC' &&
                          <div
                            className="current-plan-name-sort-asc"
                            onClick={() => sortingClick('currentPlanName', 'DESC')}
                            role="button"
                            tabIndex="0"
                          />
                        }
                        {sorting.currentPlanNameSortType === 'DESC' &&
                          <div
                            className="current-plan-name-sort-desc"
                            onClick={() => sortingClick('currentPlanName', 'ASC')}
                            role="button"
                            tabIndex="0"
                          />
                        }
                      </div>
                    </th>
                    <th>
                      <div className="table-title ri-flex-small-width">
                        {cost}
                        {sorting.currentPlanCostSortType === 'ASC' &&
                          <div
                            className="current-plan-cost-sort-asc"
                            onClick={() => sortingClick('currentPlanCost', 'DESC')}
                            role="button"
                            tabIndex="0"
                          />
                        }
                        {sorting.currentPlanCostSortType === 'DESC' &&
                          <div
                            className="current-plan-cost-sort-desc"
                            onClick={() => sortingClick('currentPlanCost', 'ASC')}
                            role="button"
                            tabIndex="0"
                          />
                        }
                      </div>
                    </th>
                    <th>
                      <div className="table-title ri-flex-large-width">
                        {data} <br /> {dataAllowanceConsume}
                        {sorting.dataUsageSortType === 'ASC' &&
                          <div
                            className="data-usage-sort-asc"
                            onClick={() => sortingClick('dataUsage', 'DESC')}
                            role="button"
                            tabIndex="0"
                          />
                        }
                        {sorting.dataUsageSortType === 'DESC' &&
                          <div
                            className="data-usage-sort-desc"
                            onClick={() => sortingClick('dataUsage', 'ASC')}
                            role="button"
                            tabIndex="0"
                          />
                        }
                      </div>
                    </th>
                    <th>
                      <div className="table-title ri-flex-large-width open-icon">
                        {treatment}
                        {sorting.treatmentSortType === 'ASC' &&
                          <div
                            className="treatment-sort-asc"
                            onClick={() => sortingClick('treatment', 'DESC')}
                            role="button"
                            tabIndex="0"
                          />
                        }
                        {sorting.treatmentSortType === 'DESC' &&
                          <div
                            className="treatment-sort-desc"
                            onClick={() => sortingClick('treatment', 'ASC')}
                            role="button"
                            tabIndex="0"
                          />
                        }
                        <button onClick={openTreatmentDetails} className="treatment-open-icon-btn">
                          <SvgIcon name="icon-system-info" className="treatment-open-icon" />
                        </button>
                      </div>
                    </th>
                    <th>
                      <div className="table-title ri-flex-elarge-width">
                        {deviceType}
                        {sorting.deviceSortType === 'ASC' &&
                          <div
                            className="device-sort-asc"
                            onClick={() => sortingClick('deviceType', 'DESC')}
                            role="button"
                            tabIndex="0"
                          />
                        }
                        {sorting.deviceSortType === 'DESC' &&
                          <div
                            className="device-sort-desc"
                            onClick={() => sortingClick('deviceType', 'ASC')}
                            role="button"
                            tabIndex="0"
                          />
                        }
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {rowData(getDataRows())}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <Pagination
        pages={numberOfPages}
        pageSize={pageSize}
        pageSizeOptions={pageSizeOptions}
        totalRecordLength={filterApplied ? totalRecords : serviceNumbersPlanDetails.length}
        restorePageNumber={0}
        page={currentPage}
        canNext={(currentPage < numberOfPages - 1)}
        canPrevious={currentPage !== 0}
        onPageChange={onPageChange}
        onPageSizeChange={onPageSizeChange}
      />
      <Modal
        isOpen={treatmentModalIsOpen}
        onShowModal={() => setTreatmentModalIsOpen(false)}
        size="large"
        className="treatment-modal"
      >
        <Modal.Header>
          <span>&nbsp;</span>
        </Modal.Header>
        <Modal.Body>
          {renderHTML(treatmentTooltip)}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default UnaddressableTable;
